// Module
var code = "<template>\n    <a if.bind=\"helpText\" class=\"help-link\" tabindex=\"0\" click.delegate=\"showHelp = !showHelp\" keydown.delegate=\"helpKeydown($event)\">${showHelp ? hideHelpTitle : helpTitle}</a>\n    <div if.bind=\"helpText\" class=\"linebreak info-box question-help ${showHelp ? 'visible' : ''}\">${helpText}</div>\n</template>";
// Exports
export default code;